import React from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import './LoginForm.css';
import BookCard from '../components/BookCard';
import VideoCard from '../components/VideoCard';
import LoginCard from '../components/LoginCard';
import tinnitus from '../assest/tinnitus.png'
import vestibular from '../assest/vestibular.png'
import centralaudi from '../assest/centralaudi.png'
import communication from '../assest/communication.png'
import { useData } from '../utils/DataContext';

Modal.setAppElement('#root');

// Dummy data for books
const dummyBooks = [
  {
    id: 1,
    title: "Tinitus",
    coverImage: tinnitus
  },

  {
    id: 2,
    title: "Vestibular Disorders",
    coverImage: vestibular
  },
  {
    id: 3,
    title: "Communication and Listining Training Unit",
    coverImage: communication
  },
  {
    id: 4,
    title: "Central Auditory Processing Disorder",
    coverImage: centralaudi
  },
    {
    id: 5,
    title: "Cochlear Implants",
    coverImage: centralaudi
  },
    {
    id: 6,
    title: "Hearing Aids",
    coverImage: centralaudi
  },

];

// Dummy data for videos
const dummyVideos = [
  {
    id: 1,
    title: "Tinnitus",
    thumbnail: tinnitus,
    videoUrl: "https://youtu.be/aEWv9KOgHg4?si=sJ6WKIKfpMVHJO0h",
  },
  {
    id: 2,
    title: "Vestibular Disorders",
    thumbnail: vestibular,
    videoUrl: "https://www.youtube.com/watch?v=upDLs1sn7g4",
  },
  {
    id: 3,
    title: "Communication and Listining Training Unit",
    thumbnail: communication,
    videoUrl: "https://www.youtube.com/watch?v=pQN-pnF0RA0",
  },
  {
    id: 4,
    title: "Central Auditory Processing Disorder",
    thumbnail: centralaudi,
    videoUrl: "https://www.youtube.com/watch?v=1Rs2ND1ryY4",
  },
   {
    id: 5,
    title: "Cochlear Implants",
    thumbnail: communication,
    videoUrl: "https://www.youtube.com/watch?v=pQN-pnF0RA0",
  },
  {
    id: 6,
    title: "Hearing Aids",
    thumbnail: centralaudi,
    videoUrl: "https://www.youtube.com/watch?v=1Rs2ND1ryY4",
  },


];

const LoginPage = () => {
  const navigate = useNavigate();
  const { updateSelectedId } = useData();
  return (
    <div className="login-page">
      <div className="logging">
        <div className="left-side">
          <div className="explanation">
            <h2>EarlySpark</h2>
             <p>
              Emphasizing early identification and rehabilitation support for students.
             </p>
          </div>
        </div>
        <div className="right-side">
          <LoginCard />
        </div>
      </div>

      <div className="cards-container">
      <div className="book-cards">
          <h2>Videos</h2>
          <div className="card-grid">
        {dummyVideos.map((video) => (
          <VideoCard
            key={video.id}
            title={video.title}
            thumbnail={video.thumbnail}
            videoUrl={video.videoUrl}
            onClick={() => {
              updateSelectedId(video.id);
              navigate('/libraryvideo');
            }}
          />
        ))}
      </div>
        </div>
        <div className="book-cards">
          <h2>Reading Material</h2>
          <div className="card-grid">
        {dummyBooks.map((book) => (
          <BookCard
            key={book.id}
            title={book.title}
            coverImage={book.coverImage}
            onClick={() => {
              updateSelectedId(book.id);
              navigate('/library');
            }}
          />
        ))}
      </div>
        </div>

     
      </div>
    </div>
  );
};

export default LoginPage;
